// It's not available on Edge or IE11

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

function nonEnumerable(target, propertyKey) {
  let descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {};

  if (descriptor.enumerable != false) {
    descriptor.enumerable = false;
    Object.defineProperty(target, propertyKey, descriptor);
  }
}

class DOMRectPolyfill {
  static fromRect(rect = {}) {
    return new DOMRect(rect.x ?? 0, rect.y ?? 0, rect.width ?? 0, rect.height ?? 0);
  }

  constructor(x, y, width, height) {
    if (x != null) {
      this.x = x;
    }

    if (y != null) {
      this.y = y;
    }

    if (width != null) {
      this.width = width;
    }

    if (height != null) {
      this.height = height;
    }
  } // DOMRect's properties are all non-enumerable


  x = 0;
  y = 0;
  width = 0;
  height = 0;

  get top() {
    return this.y;
  }

  get right() {
    return this.x + this.width;
  }

  get bottom() {
    return this.y + this.height;
  }

  get left() {
    return this.x;
  } // But it has a toJSON that does include all the properties.


  toJSON() {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left
    };
  }

}

__decorate([nonEnumerable], DOMRectPolyfill.prototype, "x", void 0);

__decorate([nonEnumerable], DOMRectPolyfill.prototype, "y", void 0);

__decorate([nonEnumerable], DOMRectPolyfill.prototype, "width", void 0);

__decorate([nonEnumerable], DOMRectPolyfill.prototype, "height", void 0);

if (typeof window !== 'undefined' && !window.DOMRect) {
  window.DOMRect = DOMRectPolyfill;
}

/**
  Shifts the coordinates of the given bounds using the provided
  x and y axis offset.

  @private
  @function shiftedBounds
  @hide
  @param {Object} bounds The original bounds.
  @param {number} dx X axis offset.
  @param {number} dy Y axis offset.
  @return {Object} The newly calculated bounds.
*/

function shiftedBounds(bounds, dx, dy) {
  return new DOMRect(bounds.x + dx, bounds.y + dy, bounds.width, bounds.height);
}
/**
  Resizes the coordinates of the given bounds using the provided
  width and height.

  @private
  @function resizedBounds
  @hide
  @param {Object} bounds The original bounds.
  @param {number} width The target width.
  @param {number} height The target height.
  @return {Object} The newly calculated bounds.
*/

function resizedBounds(bounds, width, height) {
  return new DOMRect(bounds.x, bounds.y, width, height);
}
/**
  Shifts the coordinates of the given bounds so they are relative to
  the offset.

  @private
  @function relativeBounds
  @hide
  @param {Object} bounds The original bounds.
  @param {Object} offset The offset.
  @return {Object} The newly calculated bounds.
*/

function relativeBounds(bounds, offset) {
  return shiftedBounds(bounds, -offset.left, -offset.top);
}
/**
  An empty bounds object.

  @private
  @hide
  @constant {Object} emptyBounds
*/

const emptyBounds = Object.freeze(new DOMRect(0, 0, 0, 0));

export { emptyBounds, relativeBounds, resizedBounds, shiftedBounds };
